import React from 'react';
import '../styles/CareerTimeline.css';

const CareerTimeline: React.FC = () => {
  const items = [
    {
      year: '2007',
      title: 'Foundational Engineering Journey',
      text: 'Completed B.Tech and began building a strong technical foundation that would later support work across enterprise transaction systems and modernization initiatives.'
    },
    {
      year: '2007 – 2010',
      title: 'IBM',
      text: 'Started as a software developer working closely with IBM mainframe technologies, gaining deep hands-on experience in assembler programming and core enterprise development.'
    },
    {
      year: '2010 – 2015',
      title: 'Accenture',
      text: 'Expanded into technical leadership through complex delivery, team mentoring, and strong domain engagement in authorization platforms and payment processing systems.'
    },
    {
      year: '2015 – Present',
      title: 'Fiserv / First Data',
      text: 'Moved into architectural leadership, driving modernization and transformation for mission-critical financial platforms while balancing innovation with stability and scale.'
    },
    {
      year: 'Modernization Focus',
      title: 'Mainframe + Modern Platforms',
      text: 'Led work spanning Java on z/OS, API-first integration, hybrid architecture, distributed services, and enterprise modernization patterns across large-scale platforms.'
    },
    {
      year: 'Current Direction',
      title: 'AI and Enterprise Engineering',
      text: 'I continue to explore practical AI applications, developer productivity, system intelligence, and new ways to strengthen enterprise platforms without compromising resilience.'
    }
  ];

  return (
    <div className="career-timeline">
      <div className="career-timeline-track">
        {items.map((item, idx) => (
          <div className="career-timeline-item" key={idx}>
            <div className="career-timeline-marker" />
            <div className="career-timeline-content">
              <div className="career-timeline-year">{item.year}</div>
              <div className="career-timeline-title">{item.title}</div>
              <div className="career-timeline-text">{item.text}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default CareerTimeline;